/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HealthCheckResponse } from '../models/HealthCheckResponse';
import type { Network } from '../models/Network';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CenterApiInfoService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * API capabilities
     * Returns Center contact information, example requests, and other helpful resources (e.g., links to tutorials)
     * @returns any OK
     * @throws ApiError
     */
    public homepage(): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/',
        });
    }

    /**
     * API healthcheck
     * Returns current status of Center.dev API
     * @returns HealthCheckResponse OK
     * @throws ApiError
     */
    public getHealth(): CancelablePromise<HealthCheckResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/_health',
        });
    }

    /**
     * List blockchain networks
     * Returns blockchain networks currently accessible through this API
     * @returns Network OK
     * @throws ApiError
     */
    public networksV1NetworksGet(): CancelablePromise<Array<Network>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/networks',
        });
    }

}